<template>
  <div>
    <div class="sidenav-container">
      <!-- Sidenav for settings -->
      <div class="sidenav">
        <SettingsLayout active="RecurringSettings"></SettingsLayout>
      </div>
      <!-- General settings content -->
      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <b-row class="px-3 border-bottom">
          <b-col cols="12" class="px-0">
            <h2
              class="custom-page-title mb-2 mt-1 px-4"
              style="position:relative;bottom:4px;"
            >Recurring Invoice</h2>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block py-3"
          style="padding-left:17px !important;padding-right:17px !important;overflow-y: scroll;height: calc(100vh - 142px);overflow-x:hidden"
        >
          <!-- Validation for sales -->
          <b-form @submit.prevent="onSubmit">
            <div class="page">
              <b-row>
                <b-col>
                  <b-form-checkbox
                    plain
                    class="mb-4"
                    v-model.trim="field.rec_inv_code_field"
                  >Show customize recurring invoice code option</b-form-checkbox>
                  <br />
                </b-col>
              </b-row>

              <b-form-group class="mb-1">
                <b-row style="max-width:900px; font-family:sans-serif">
                  <!--  Description -->
                  <b-col xl="7" lg="7" cols="12">
                    <b-form-group label="Customer Notes" label-for="description" breakpoint="md">
                      <b-form-textarea
                        name="cus_notes"
                        v-validate="'max:2000'"
                        :rows="6"
                        id="cus_inv_notes"
                        v-model="field.cus_inv_notes"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('cus_notes')"
                      >Customer Notes should not exceed 2000 characters</span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form-group>

              <b-form-group>
                <b-row style="max-width:900px; font-family:sans-serif">
                  <!--  Description -->
                  <b-col xl="7" lg="7" cols="12">
                    <b-form-group
                      label="Terms and conditions"
                      label-for="description"
                      breakpoint="md"
                    >
                      <b-form-textarea
                        v-model="field.internal_notes"
                        name="desc_notes"
                        v-validate="'max:2000'"
                        :rows="6"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('desc_notes')"
                      >Terms and conditions should not exceed 2000 characters</span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form-group>

              <!-- footer block -->
            </div>
            <div class="footer sidenav-footer" style="box-shadow:0 -4px 5px -3px #ccc;">
              <div class="form-action" style="background:none !important;">
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  class="btn-rounded mr-3"
                  :disabled="submitted"
                >
                  <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import SettingsLayout from "@/components/Layout/SettingsLayout";
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: { SettingsLayout },
  data() {
    return {
      index_value: "",
      error_show: false, // to show the error message
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      submitted: false
    };
  },

  methods: {
    removeRow(index) {
      if (this.field.custom_field.length > 1) {
        this.field.custom_field.splice(index, 1);
      }
    },
    settingsdata() {
      var data = {
        field: this.field,
        stg_menu: "Recurring Invoice",
        table_name: "cbs_rec_inv_tbl_tns_usr_hdr"
        // custom_field: this.custom_field
      };

      this.$store.dispatch("settings/invoice", data).then(() => {
        this.$router.push({
          name: this.$route.name,
          query: {
            update:
              this.$route.query.update || this.$route.query.update == true
                ? false
                : true
          }
        });
        //  code for notificatin display
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: "Recurring Invoice settings updated successfully",
          type: "success",
          showCloseButton: true
        });
      });
    },
    async onSubmit() {
      // await this.removeRoute();
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;
          this.settingsdata();
          setTimeout(() => {
            this.submitted = false;
          }, 3000);
        } else {
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    }
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Recurring Invoice",
        stg_name: "rec_inv_settings_details"
      })
      .then(() => {
        next();
      });
  },
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Recurring Invoice",
        stg_name: "rec_inv_settings_details"
      })
      .then(() => {
        next();
      });
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      field: state =>
        state.settings.list["Recurring Invoice"] || { custom_field: {} },
      list: state => state.settings.list
    }),
    rec_inv_settings_details: {
      get() {
        return this.$store.state.permission.rec_inv_settings_details;
      },
      set(val) {
        this.$store.state.permission.rec_inv_settings_details = val;
      }
    }
  }
};
</script>